
import React from 'react'
import SelectField from './SelectField'
import { getData } from 'country-list'

/**
 * Options is the list of countries.
 */

const options = getData().map(({ code, name }) => {
  return {
    label: name,
    value: code
  }
})

/**
 * CountrySelect component.
 */

export default function CountrySelect({ ...props }) {
  return <SelectField {...props}>
    <option value="">Select</option>
    {options.map(({ label, value }) => {
      return <option key={value} value={value}>{label}</option>
    })}
  </SelectField>
}
